import ramses from '../api/ramses'

export const getAllProducts = async () => {
  try {
    return await ramses.get('registration/files/products')
  } catch (err) {
    return err.response
  }
}

export const userLink = async (data, hash) => {
  try {
    return await ramses.post(`/registration/${hash}`, data)
  } catch ({ response }) {
    return response
  }
}

export const uploadAllFiles = async (data, hash) => {
  try {
    const formData = new FormData()

    Object.entries(data).forEach(([key, file]) => {
      formData.append(key, file)
    })

    return await ramses.post(`/registration/file/${hash}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  } catch ({ response }) {
    return response
  }
}

export const findByHash = async hash => {
  try {
    return await ramses.get(`registration/${hash}`)
  } catch (err) {
    return err.response
  }
}

export const findImportedFilesByRegistrationId = async registrationId => {
  try {
    return await ramses.get(`registration/files/${registrationId}`)
  } catch (err) {
    return err.response
  }
}

export const webHookRequest = async () => {
  try {
    return await ramses.post('webhook/salesforce')
  } catch (err) {
    return err.response
  }
}
